import { spawn } from 'redux-saga/effects'
import rulesSaga from './rules.saga'
import amenitiesSaga from './amenities.saga'
import neighborhoodsSaga from './neighborhoods.saga'

export default function*() {
  yield [spawn(rulesSaga), spawn(amenitiesSaga), spawn(neighborhoodsSaga)]
}
